// imports
import { FC } from "react";
import { UsaStates } from "usa-states";
import { Controller, useFormContext } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
// interface
import { StateSelectorProps } from "../interfaceTypes";

const StateSelector: FC<StateSelectorProps> = ({ name, label, disabled }) => {
  const { control } = useFormContext();

  const usStates = new UsaStates();
  const states = usStates.states.map((s) => ({
    label: s.abbreviation,
    value: s.abbreviation,
    fullName: s.name,
  }));

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Autocomplete
          {...field}
          sx={{ marginTop: '8px' }}
          options={states}
          getOptionLabel={(option) => option.label}
          value={states.find((s) => s.value === field.value) || null}
          onChange={(_, newValue) => field.onChange(newValue?.value || "")}
          disabled={disabled}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label={label} 
              error={!!fieldState.error} 
              helperText={fieldState.error?.message} 
            />
          )}
        />
      )}
    />
  );
};

export default StateSelector;
